import React, { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import Icon from '../../../components/AppIcon';


const ConversationThread = ({ messages, isTyping = false }) => {
  const messagesEndRef = useRef(null);
  const containerRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  if (messages?.length === 0 && !isTyping) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="MessageCircle" size={32} className="text-primary" />
          </div>
          <h3 className="text-lg font-heading font-heading-semibold text-foreground mb-2">
            Start Your Trip Planning
          </h3>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Tell me about your ideal state park adventure! I can help you find parks, plan activities, suggest accommodations, and create a complete itinerary.
          </p>
          <div className="mt-6 space-y-2">
            <div className="text-xs font-medium text-foreground mb-2">Try asking:</div>
            <div className="space-y-1 text-xs text-muted-foreground">
              <div>"I want a 3-day camping trip in California"</div>
              <div>"Find family-friendly parks with hiking trails"</div>
              <div>"Plan a weekend getaway near Denver"</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="flex-1 overflow-y-auto p-4 space-y-4"
      style={{ scrollBehavior: 'smooth' }}
    >
      <div className="max-w-4xl mx-auto">
        {messages?.map((message, index) => (
          <MessageBubble
            key={message?.id || index}
            message={message?.content}
            isUser={message?.isUser}
            timestamp={message?.timestamp}
          />
        ))}
        
        {isTyping && (
          <MessageBubble isTyping={true} isUser={false} message="" timestamp={new Date()?.toISOString()} />
        )}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ConversationThread;